var newsletter = new function() {

    var me = this;

    this.bindEvents = function() {
        $("[data-form-newslettersubscribe]").bind("submit", function() {
            var form = $(this);
            var params = {
              'email': form.find("input[type='email']").val(),
              'lang': $('html').attr('lang'),
              '_token': window.Laravel.csrfToken
            };
            if($(this).valid()){
              $.post("/module/newsletter/subscribe",params, function(response) {
                  if(parseInt(response.code) == 1)
                    form.find("input[type='email']").val('');
                  $("[data-form-newslettermsg]").html(response.msg);
              },"json");
            }
            return false;
        });
    };
}

$(document).ready(function() {
    newsletter.bindEvents();
});

$(document).ready(function(){
    var popupLink = $(".hiddenPopup");
    if(popupLink.length == 1){
      var type = popupLink.data("type");

      if(type!=null){
        type = type.replace(/\s*$/,"");

        if(type === "inline") {
            popupLink.magnificPopup({
                mainClass: 'mfp-with-zoom',
                removalDelay: 400,
                items: {
                    src: '#popup',
                    type: type
                }
            });
        } else{
            popupLink.magnificPopup({
                type: 'iframe',
                mainClass: 'mfp-with-zoom',
                removalDelay: 400,
                iframe: {
                    markup: '<div class="mfp-iframe-scaler">' +
                    '<div class="mfp-close"></div>' +
                    '<iframe id="player" class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
                    '</div>',
                    patterns: {
                        youtube: {
                            index: 'youtube.com/',
                            id: 'v=',
                            src: 'h%id%&autoplay=1'
                        }
                    }
                }
            });
        }
      }
    }
});

$(window).on('load',function () {
    $(".hiddenPopup").trigger("click");
});

$(document).ready(function () {
    var el = $('[data-cookies]');

    $('[data-closecookies]').on('click', function () {
        el.fadeOut();
        Cookies.set('cookies_info', '1', {expires: 12});
    });

    var myCookie = Cookies.get('cookies_info');
    if (myCookie === undefined) {
        el.show();
    }
});
$(document).ready(function () {
  $('.js-openMenu').on("click", function () {
    $(this).toggleClass('active');
    $('.mobileMenu').toggleClass('opened');
    $('body').addClass('noscroll');
  });

  $('.js-close').on("click", function () {
    $('.mobileMenu').removeClass('opened');
    $('body').removeClass('noscroll');
  });

  $('body').on("click", '.js-prev', function () {
    
    var el = $(this);
    $(".mobileMenu ul.opened").removeClass("opened");
    $("[data-menu].actived").removeClass("actived");
    $(".js-prev").remove();
  });

  $('.mobileMenu li').each(function() {
    if ( $(this).find('ul').length ) {
      $(this).addClass('withSubmenu');
    }
  });
  

  $("[data-menu]:not(.actived)").on("click", function (e) {
    if( $(this).hasClass('actived')) { 
      window.location.href = $(this).attr('href');
    } else {
      e.preventDefault();
      var el = $(this);
      el.addClass("actived");
      el.next('ul').addClass("opened");
      $('.mobileMenu__tools').append("<a class='js-prev mobilePrev'></a>");
    }
    
  });

  $('.js-searchBox .searchBox__icon').on('click', function() {
    $(this).parent().toggleClass('active');
    $('.js-searchBox input').focus();
    $('.mobileMenu__language').toggleClass('hide');
  });

});

// main slider
$('.js-slider').on('init reInit afterChange', function() {
    $('.slick-slide:not(.slick-current)').removeClass('slider__item--visible');
    $('.js-slider .slick-current').addClass('slider__item--visible');
});
$('.js-slider').slick({
    arrows: true,
    speed: 700,
    fade: true,
    autoplaySpeed: 7000,
    dots: true,
    infinite: true,
    autoplay: true
});
//slider--3 dots
if ( $('.js-slider--3').length ) {
    $('.js-slider--3 .slick-dots button').each(function(i) {
        i++;
        n=i;
        $(this).attr('data-number',++i).append('<span>0'+ n +'</span>');
    });
}
// scrolledGallery for mobiles
let scrolledGallery = function() {
    $('.js-scrolledGallery').slick({
        arrows: true,
        speed: 700,
        fade: true,
        autoplaySpeed: 7000,
        dots: true,
        infinite: true,
        autoplay: false
    });
}
if ($(window).width() < 800) {
    scrolledGallery();
}
$(window).on('resize', function(){
    if ($(window).width() < 800) {
        scrolledGallery();
    }
});
//logoSlider 
if ( $('.js-logoSlider').length ){
    $('.js-logoSlider').slick({
        arrows: true,
        speed: 700,
        autoplaySpeed: 7000,
        dots: true,
        infinite: true,
        autoplay: true,
        slidesToShow: 6,
        slidesToScroll: 6,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 4
            }
          },
          {
            breakpoint: 900,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
          }
          ,
          {
            breakpoint: 500,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
          }
        ]
    });
}
var elements = document.querySelectorAll('.js-sliderGallery');
if ( elements.length>0){
  $('.js-sliderGallery').slick({
      arrows: true,
      speed: 700,
      autoplaySpeed: 7000,
      dots: true,
      infinite: true,
      autoplay: false,
      slidesPerRow: 5,
      rows: 2,
      responsive: [
        {
          breakpoint: 678,
          settings: {
            slidesPerRow: 2,
            rows: 2,
          }
        }
      ]
  });
}

  //productSlider
  if ( $('.js-productSlider').length ) {
    $('.js-productSlider').slick({
        speed: 700,
        autoplaySpeed: 7000,
        dots: false,
        autoplay: false,
        fade: true,
        arrows: true,
        slidesToShow: 1,
 	      slidesToScroll: 1,
        asNavFor: '.js-productSliderThumbs',
        responsive: [
          {
            breakpoint: 1240,
            settings: {
              dots: false
            }
          }
        ]
    });

    $('.js-productSliderThumbs').slick({
        speed: 700,
        autoplaySpeed: 7000,
        dots: false,
        autoplay: false,
        arrows: true,
        slidesToShow: 4,
 	      slidesToScroll: 1,
        asNavFor: '.js-productSlider',
        focusOnSelect: true,
        responsive: [
          {
            breakpoint: 1240,
            settings: {
              dots: false
            }
          },
          {
            breakpoint: 700,
            settings: {
              slidesToShow: 2
            }
          }
        ]
    });
  }
/*! modernizr 3.6.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-webp-setclasses !*/
 !function(e,n,A){function o(e,n){return typeof e===n}function t(){var e,n,A,t,a,i,l;for(var f in r)if(r.hasOwnProperty(f)){if(e=[],n=r[f],n.name&&(e.push(n.name.toLowerCase()),n.options&&n.options.aliases&&n.options.aliases.length))for(A=0;A<n.options.aliases.length;A++)e.push(n.options.aliases[A].toLowerCase());for(t=o(n.fn,"function")?n.fn():n.fn,a=0;a<e.length;a++)i=e[a],l=i.split("."),1===l.length?Modernizr[l[0]]=t:(!Modernizr[l[0]]||Modernizr[l[0]]instanceof Boolean||(Modernizr[l[0]]=new Boolean(Modernizr[l[0]])),Modernizr[l[0]][l[1]]=t),s.push((t?"":"no-")+l.join("-"))}}function a(e){var n=u.className,A=Modernizr._config.classPrefix||"";if(c&&(n=n.baseVal),Modernizr._config.enableJSClass){var o=new RegExp("(^|\\s)"+A+"no-js(\\s|$)");n=n.replace(o,"$1"+A+"js$2")}Modernizr._config.enableClasses&&(n+=" "+A+e.join(" "+A),c?u.className.baseVal=n:u.className=n)}function i(e,n){if("object"==typeof e)for(var A in e)f(e,A)&&i(A,e[A]);else{e=e.toLowerCase();var o=e.split("."),t=Modernizr[o[0]];if(2==o.length&&(t=t[o[1]]),"undefined"!=typeof t)return Modernizr;n="function"==typeof n?n():n,1==o.length?Modernizr[o[0]]=n:(!Modernizr[o[0]]||Modernizr[o[0]]instanceof Boolean||(Modernizr[o[0]]=new Boolean(Modernizr[o[0]])),Modernizr[o[0]][o[1]]=n),a([(n&&0!=n?"":"no-")+o.join("-")]),Modernizr._trigger(e,n)}return Modernizr}var s=[],r=[],l={_version:"3.6.0",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,n){var A=this;setTimeout(function(){n(A[e])},0)},addTest:function(e,n,A){r.push({name:e,fn:n,options:A})},addAsyncTest:function(e){r.push({name:null,fn:e})}},Modernizr=function(){};Modernizr.prototype=l,Modernizr=new Modernizr;var f,u=n.documentElement,c="svg"===u.nodeName.toLowerCase();!function(){var e={}.hasOwnProperty;f=o(e,"undefined")||o(e.call,"undefined")?function(e,n){return n in e&&o(e.constructor.prototype[n],"undefined")}:function(n,A){return e.call(n,A)}}(),l._l={},l.on=function(e,n){this._l[e]||(this._l[e]=[]),this._l[e].push(n),Modernizr.hasOwnProperty(e)&&setTimeout(function(){Modernizr._trigger(e,Modernizr[e])},0)},l._trigger=function(e,n){if(this._l[e]){var A=this._l[e];setTimeout(function(){var e,o;for(e=0;e<A.length;e++)(o=A[e])(n)},0),delete this._l[e]}},Modernizr._q.push(function(){l.addTest=i}),Modernizr.addAsyncTest(function(){function e(e,n,A){function o(n){var o=n&&"load"===n.type?1==t.width:!1,a="webp"===e;i(e,a&&o?new Boolean(o):o),A&&A(n)}var t=new Image;t.onerror=o,t.onload=o,t.src=n}var n=[{uri:"data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA=",name:"webp"},{uri:"data:image/webp;base64,UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAABBxAR/Q9ERP8DAABWUDggGAAAADABAJ0BKgEAAQADADQlpAADcAD++/1QAA==",name:"webp.alpha"},{uri:"data:image/webp;base64,UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA",name:"webp.animation"},{uri:"data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=",name:"webp.lossless"}],A=n.shift();e(A.name,A.uri,function(A){if(A&&"load"===A.type)for(var o=0;o<n.length;o++)e(n[o].name,n[o].uri)})}),t(),a(s),delete l.addTest,delete l.addAsyncTest;for(var p=0;p<Modernizr._q.length;p++)Modernizr._q[p]();e.Modernizr=Modernizr}(window,document);
$(document).ready(function(){

  /**
   * fix passive listenere psi
   */
  jQuery.event.special.touchstart = {
  	setup: function( _, ns, handle ){
    	this.addEventListener("touchstart", handle, { passive: true });
    }
  };

    /**
   * cookies
   */
  function createCookie(name, value, s) {
    console.log("create cookie "+name+" "+value+" "+s)
    if (s) {
        var date = new Date();
        date.setMonth(date.getMonth() + s)
        var expires = "; expires=" + date.toGMTString();
    } else
        var expires = "";
    document.cookie = name + "=" + value + expires + "; path=/";
  }
  function getCookie(name) {
    var dc = document.cookie;
    var prefix = name + "=";
    var begin = dc.indexOf("; " + prefix);
    if (begin == -1) {
        begin = dc.indexOf(prefix);
        if (begin != 0) return null;
    } else {
        begin += 2;
        var end = document.cookie.indexOf(";", begin);
        if (end == -1) {
            end = dc.length;
        }
    }
    return unescape(dc.substring(begin + prefix.length, end));
  }

  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }


  //if Sidebar exists
  if ( $('.main__sidebar').length ) {
    $('.offerBoxes').addClass('offerBoxes--withSidebar');
  }

  // go to form message
  if ( $('.formErrors__item').length ) {
    $('html, body').animate({
        scrollTop:  $('.formErrors__item').first().offset().top - 200
    }, 600);
  }

  //language - select
  $('.languageBox__select').on('click', function() {
      $('.languageBox__list').toggleClass('visible');
      return false;
  });

  // aos
  if ( $('[data-aos]').length ) {
      AOS.init({
          offset: 50,
          duration: 500
      });
  }

  // plus / minus add to clipboard
  if ( $('.product__infoButton').length ) {

    $('.js-product__infoButton--circlePlus').on('click', function(e) {
        e.preventDefault();
        let counter = $(this).siblings('.js-product__infoButton--counter');
        let count = parseInt(counter.text());
        count ++;
        counter.text(count);
        $(this).parent().find('input').val(count);
        return false;
    });

    $('.js-product__infoButton--circleMinus').on('click', function(e) {
        e.preventDefault();
        let counter = $(this).siblings('.js-product__infoButton--counter');
        let count = parseInt(counter.text());
        if (count > 0) {
            count --;
            counter.text(count);
            $(this).parent().find('input').val(count);
        }
    });
  }

  // lazyload
  const observer = lozad(); // lazy loads elements with default selector as '.lozad'
  observer.observe();

  // scrolled menu
  if ($(window).width()<1240){
          $('.js-header').addClass('header--scrolled');
  } else {
      $('.js-header').removeClass('header--scrolled');
      // $('.js-header').removeClass('open');
  }

  // relax init
  if ($('.rellax').length) {
      var rellax = new Rellax('.rellax', {
        // wrapper: '.rellax-parent',
        // relativeToWrapper: true,
      });
  }

  // js-up
  $(".js-up").on("click", function () {
      var body = $("html, body");
      body.stop().animate({scrollTop: 0}, 1500, 'swing');
  });

  //go to form
  $('.js-gotoform').on('click', function(){
      var anchor = $('.footer__form');
      if (anchor.length) {
          $('html, body').animate({
              scrollTop:  $(anchor).offset().top
          }, 600);
          return false;
    }
  });

  //go to map
  $('.js-gotomap').on('click', function(){
    let anchor = $('.contact__map');
    if (anchor.length) {
        $('html, body').animate({
            scrollTop:  $(anchor).offset().top - 100
        }, 600);
        return false;
    }
  });


  // scrolled menu
  if ($(window).scrollTop() > 0) {
    $('.js-header').addClass('header--scrolled');

  }

  //search
  $('.js-header__search').on('click', function(){
      $('.header .header__searchBox form').toggleClass('header__searchBoxForm--hidden');
      $('.header .header__searchBox').slideToggle(300);
  });
  $('.js-header__searchBoxIcon').on('click', function(){
    $('[data-search-form]').submit();
  });

  // sticky
//   if ( $('.sidebarMenu > div').length && ( $(window).width() > 1024 ) && ( $('.main__modules').height() >= $('.main__sidebar div[data-sticky-class]').height()) )  {
//     let sticky = new Sticky('.sidebarMenu > div');
//   }

  //file input
  if ( $('.styledFormItems--file').length ) {
    var fileInput  = document.querySelector( ".styledFormItems--file" ),
      button     = document.querySelector( ".styledFormItems--file" ),
      the_return = document.querySelector(".styledForm__fileName");

    button.addEventListener( "keydown", function( event ) {
        if ( event.keyCode == 13 || event.keyCode == 32 ) {
            fileInput.focus();
        }
    });
    button.addEventListener( "click", function( event ) {
      fileInput.focus();
      return false;
    });
    fileInput.addEventListener( "change", function( event ) {
        //the_return.innerHTML = this.files[0].name;
        console.log(this.files.length);
        for(var i=0;i<this.files.length;i++){
          var html = '<div data-boxitem>';
          html+= '<div class="registerPage__addedPerson styledFormItems--input styledFormItems">'+this.files[i].name;
          html+= '<input type="hidden" name="fileindex[]" value="'+i+'"/>';
          html+= '<span class="registerPage__removePerson js-registerPage__removePerson" data-boxitem-remove></span></div></div>';
          $("[data-files-container]").append(html);
        }
    });
  }

 // contrast

    // createCookie("contrast", '', 12);
    var pageColor = getCookie("contrast");

    $('.tools__contrastItem').on('click',function(){
        pageColor = getCookie("contrast");
        var color = $(this).attr('data-contrast');
        var pagecolor = 'body--'+color;
        if ( pageColor == 'undefined' ) {
            createCookie("contrast", '', 12);
            checkColor(color);
        } else if ( pageColor == pagecolor ) {
            // clearColor();
        } else {
            checkColor(color);
        }
    });

    var checkColor = function(color) {
        clearColor();
        $('body').addClass('body--'+color);
        if ($('.body--'+color).length) {
            setCookie('contrast', 'body--'+color, 12);
        } else {
            setCookie('contrast', '', 12);
        }
    }

    var clearColor = function() {
        $('body').removeClass('body--light').removeClass('body--dark').removeClass('body--none');
        setCookie('contrast', '', 12);
    }

    if (pageColor === 'body--light') {
        $('body').addClass('body--light');
        $('.js-contrast__item--light').addClass('contrast__item--active');
        $('.js-contrast__item--dark').removeClass('contrast__item--active');
    } else if (pageColor === 'body--dark') {
        $('body').addClass('body--dark');
        $('.js-contrast__item--light').removeClass('contrast__item--active');
        $('.js-contrast__item--dark').addClass('contrast__item--active');
    } else {
        $('body').removeClass('body--dark, body--light');
        $('.js-contrast__item--light,.js-contrast__item--dark').removeClass('contrast__item--active');
    }

    //font-size changing
    // createCookie("fontsize", '', 12);
    var fontSize = getCookie("fontsize");

    $('.tools__sizeItem').on('click',function(){
        fontSize = getCookie("fontsize");
        var size = $(this).attr('data-size');
        var fontsize = 'body--'+size;
        if ( fontSize == 'undefined' ) {
            createCookie("fontsize", '', 12);
            checkSize(size);
        } else if ( fontSize == fontsize ) {
            // clearSize();
        } else {
            checkSize(size);
        }
    });

    var checkSize = function(size) {
        $('body').removeClass('body--medium').removeClass('body--big').removeClass('body--small').addClass('body--'+size);
        if ($('.body--'+size).length) {
            setCookie('fontsize', 'body--'+size, 12);
        } else {
            setCookie('fontsize', '', 12);
        }
    }
    var clearSize = function() {
        $('body').removeClass('body--big').removeClass('body--medium').removeClass('body--small');
        setCookie('fontsize', '', 12);
    }

    if (fontSize === 'body--big') {
        $('body').addClass('body--big');
    } else if (fontSize === 'body--medium') {
        $('body').addClass('body--medium');
    } else {
        $('body').removeClass('body--big, body--medium');
    }


    // front video popup
    $('.textBlock__video').magnificPopup({
      disableOn: 700,
      type: 'iframe',
      mainClass: 'mfp-fade',
      removalDelay: 160,
      preloader: false,

      fixedContentPos: false
    });

    
    $('.js-clipboard__pdf').on('click', function(){
        $('.clipboard__popup--pdf, .clipboard__popupBg').addClass('visible');
    });

    $('.js-clipboard__question').on('click', function(){
        $('.clipboard__popup--question, .clipboard__popupBg').addClass('visible');
    });

    $('.js-clipboard__popupClose').on('click', function(){
        $('.clipboard__popup, .clipboard__popupBg').removeClass('visible');
    });
    

    var contactPersonCounter = 0;
    $("[data-contactperson-add]").click(function(){
      var name = $("[data-contact-name]").val();
      var html = '<div data-contactperson-id="'+contactPersonCounter+'">';
      html+= '<div class="registerPage__addedPerson styledFormItems--input styledFormItems">'+name;
      html+= '<span class="registerPage__removePerson js-registerPage__removePerson" data-contactperson-remove="'+contactPersonCounter+'"></span></div>'
      html+= '<input name="contact[name][]" value="'+name+'" type="hidden"/>';
      html+= '<input name="contact[phone][]" value="'+$("[data-contact-phone]").val()+'" type="hidden"/>';
      html+= '<input name="contact[email][]"  value="'+$("[data-contact-email]").val()+'" type="hidden"/>';
      html+= '<input name="contact[department][]" value="'+$("[data-contact-department]").val()+'" type="hidden"/>';
      html+= '</div>';
      $("[data-contactperson-cont]").append(html);
      $("[data-contact-name]").val('');
      $("[data-contact-phone]").val('');
      $("[data-contact-department]").val('');
      $("[data-contact-email]").val('');
      contactPersonCounter++;
    });

    $("select[name='premiumProducts']").bind('change',function(){
      var value = $(this).find('option:selected').val();
      if(value!="" && $("[data-product='"+value+"']").length==0){
        var html = '<div data-boxitem>';
        html+= '<div class="registerPage__addedPerson styledFormItems--input styledFormItems">'+$(this).find('option:selected').text();
        html+= '<input type="hidden" name="product[]" data-product="'+value+'" value="'+$(this).find('option:selected').text()+'"/>';
        html+= '<input type="hidden" name="productid[]" value="'+value+'"/>';
        html+= '<span class="registerPage__removePerson js-registerPage__removePerson" data-boxitem-remove></span>';
        html+= '</div></div>';
        $("[data-product-container]").append(html);
      }
    });

    $("body").on('click','[data-boxitem-remove]',function(){
      $(this).closest('[data-boxitem]').remove();
    });

}); // end document ready

$(window).on('load', function(){
});

$(window).on("scroll", function () {

    $('.header .header__searchBox').slideUp(300);
    $('.header .header__searchBox form').addClass('header__searchBoxForm--hidden');

    // js-up
    var scroll = $(window).scrollTop();
    if (scroll > 600) {
        $(".js-up").addClass("visible");
    } else {
        $(".js-up").removeClass("visible");
    }

    // scrolled menu
    if ($(window).scrollTop() > 0){
    $('.js-header').addClass('header--scrolled');
    } else {
    if ($(window).width()>1240){
        $('.js-header').removeClass('header--scrolled');
        // $('.js-header').removeClass('open');
    }
    }

}); // end onscroll

var validator = new function() {
    this.methods = function() {
        jQuery.validator.addMethod("phone", function(value, element) {
            var slug = /^[0-9\-]+$/;
            return slug.test(value) && value.length == 9;
        }, Laravel.lang.validation.phone);
    };
};

$(document).ready(function() {
    validator.methods();

    $("[data-search-form] input").bind("keyup",function(){
      var value = $(this).val();

      if(value.length>2){
        var currentRequest = null;

        currentRequest = jQuery.ajax({
            type: 'POST',
            data: {
              'phrase':value,
              '_token': window.Laravel.csrfToken,
              'lang': $('html').attr('lang')
            },
            url: '/module/search/hint',
            beforeSend : function()    {
                if(currentRequest != null) {
                    currentRequest.abort();
                }
            },
            success: function(data) {
                $("[data-search-form] ul").html('');
                if(Object.keys(data.results).length>0){
                  for (var prop in data.results) {
                    // for(var item in data.results[prop]){
                      var template = $("#search-hint-template").html();
                      var stone = Handlebars.compile(template)({"results":data.results[prop]});
                      var items = $.parseHTML(stone);
                      // console.log(stone);
                      $("[data-search-hintcontainer]").append("<li><h2>"+Laravel.lang.search[prop]+"</h2></li>");
                      $("[data-search-hintcontainer]").append(items);
                    // }
                    $("[data-search-hintcontainer]").addClass('visible');
                  }
                }else{
                  $("[data-search-hintcontainer]").removeClass('visible')
                }
            },
            error:function(e){
              // Error
            }
        });
      }else{
        $("[data-search-hintcontainer]").removeClass('visible')
      }
    });
});

//# sourceMappingURL=front.js.map
